exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-select[data-v-9a6e2804]{display:block;margin:0;font-weight:400}.filter-select__label[data-v-9a6e2804]{display:block;margin-bottom:4px;font-size:12px;color:#4e5560}.filter-select .form-control[data-v-9a6e2804]{width:170px;height:34px;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9a6e2804","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/default/filterSelect.vue
// module id = 897
// module chunks = 0